import { getCurrentInstance, watchEffect, ref } from 'vue';
import { AlarmWebsocket } from '@blade/common/utils/websocket';
import { LoginModule } from '@blade/common/store/login';
import { SIDECODE } from '@blade/common/constants/code';
import { getAlarmList } from '@blade/common/api/alarm-center';
import { useMonitoringStore } from '@blade-sxp/monitoring-center/store';
import { ControlModule } from '@blade-sxp/monitor/store/control';
const ALARM_MAX = 30;
const ALARM_DELAY_TIME = 5000;
export const useAlarmList = () => {
    const store = useMonitoringStore();
    const alarmList = ref([]);
    let ws = undefined;
    const vm = getCurrentInstance();
    let alarmDict = new Map();
    const showMsgList = ref([]);
    const dialogVisible = ref(false);
    const alarmDetail = ref({});
    let alarmTimer;
    watchEffect(() => {
        const checkedTasks = store.checkedTasks;
        showMsgList.value = alarmList.value?.filter((item) => checkedTasks.includes(String(item?.taskConsist?.taskId))).slice(0, 30);
    });
    const checkPermission = () => {
        return getPermission();
    };
    const initWebSocket = () => {
        ws = new AlarmWebsocket(getWsUrl());
        ws.setOnMessage(websocketonmessage);
    };
    const closeWebSocket = () => {
        ws?.close();
    };
    const websocketonmessage = (e) => {
        // 获取ws告警数据
        const msgData = JSON.parse(e.data);
        if (msgData.incidentStatus === 'DELETE')
            return;
        if (msgData.incidentType === 'FACE_MATCH') {
            const param = {
                trackId: String(msgData.faceAnnotation.trackId),
                deviceId: String(msgData.deviceId),
                taskId: String(msgData.taskConsist.taskId),
                taskName: String(msgData.taskConsist.taskName),
                level: String(msgData.level),
            };
            ControlModule.addSelectMap(param);
            store.updateAlarmDeviceId(msgData.deviceId);
            store.updateAlarmTaskId(msgData?.taskConsist?.taskId);
        }
        alarmReceiveDialog(msgData); // 任务接受告警弹框逻辑
        [alarmList.value, alarmDict] = reCalculateAlarmData(alarmList.value, msgData, alarmDict);
    };
    /** 告警弹窗 start */
    const alarmReceiveDialog = (msgData) => {
        if (alarmTimer || dialogVisible.value)
            return;
        alarmTimer = window.setTimeout(() => {
            alarmTimer = undefined;
            const alarmTaskId = String(msgData?.taskConsist?.taskId);
            if (store.recieveAlerts.indexOf(alarmTaskId) === -1)
                return;
            alarmDetail.value = { ...msgData };
            dialogVisible.value = true;
        }, ALARM_DELAY_TIME);
    };
    const closeDialog = () => {
        dialogVisible.value = false;
    };
    const confirmDialog = () => {
        closeDialog();
    };
    const updateDialog = () => {
        closeDialog();
    };
    /** 告警弹窗 end */
    const fetchAlarmList = async () => {
        const list = (await getAlarmListData()) || [];
        [alarmList.value, alarmDict] = translateAlarmData(list, alarmDict);
    };
    // 查看告警详情, 跳转到告警页面
    const handleAlarmDetail = (detail) => {
        const id = detail.id;
        if (store.recieveAlerts.indexOf(id) > -1) {
            alarmReceiveDialog(detail);
            return;
        }
        const router = vm?.proxy?.$router;
        router &&
            window.open(`${router.resolve({
                path: '/alarmCenter',
                query: {
                    recordIds: id,
                },
            }).href}`, '_blank');
    };
    // 查看更多，跳转告警页面
    const handleAlarmCenter = () => {
        const router = vm?.proxy?.$router;
        router && window.open(`${router.resolve({ path: '/alarmCenter' }).href}`, '_blank');
    };
    return { checkPermission, initWebSocket, fetchAlarmList, handleAlarmDetail, handleAlarmCenter, confirmDialog, updateDialog, closeDialog, closeWebSocket, showMsgList, dialogVisible, alarmDetail };
};
const getWsUrl = () => {
    return (process.env.NODE_ENV === 'development' ? process.env.VUE_APP_MSG_WS : `wss://${window.location.host}/${process.env.VUE_APP_MSG_WS}`);
};
const getPermission = () => {
    const permissions = LoginModule.permissions || [];
    const permission = permissions.find((item) => item.code === SIDECODE.ALARM_CENTER);
    return permission?.enable;
};
const getAlarmListData = () => {
    const reqParam = {
        alertLevel: '',
        deviceIds: [],
        incidentStatus: 'CONTINUE',
        incidentTypes: [],
        keyWord: '',
        page: 1,
        size: 500,
    };
    return getAlarmList(reqParam).then((res) => {
        return res?.list || [];
    });
};
const translateAlarmData = (list, dict) => {
    const newList = [];
    // 遍历 list 数组，将每个元素按照 taskid 存储到 dataDict 中
    for (const item of list) {
        const taskId = item?.taskConsist?.taskId;
        const alarmNumber = dict.get(taskId) ?? 0;
        if (alarmNumber >= ALARM_MAX) {
            continue;
        }
        newList.push(item);
        dict.set(taskId, alarmNumber + 1);
    }
    return [newList, dict];
};
const reCalculateAlarmData = (list, item, dict) => {
    const taskId = item?.taskConsist?.taskId;
    const alarmNumber = dict.get(taskId) ?? 0;
    if (alarmNumber >= ALARM_MAX) {
        const lastIndex = list.findLastIndex((item) => item?.taskConsist?.taskId === taskId);
        list.splice(lastIndex, 1);
    }
    else {
        dict.set(taskId, alarmNumber + 1);
    }
    list.unshift(item);
    return [list, dict];
};
